import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import Fab from '../Fab';
import AddIcon from '../Icons/Add';
import acceptFiles from '../lib/acceptFiles';

const Privacy = styled.p`
  margin: 24px 0;
  font-size: 0.6em;
  line-height: 1.5;
`;

const UploadHint = styled.div`
  color: rgba(0, 0, 0, 0.54);
  font-size: 0.75rem;
  font-weight: bold;
  margin: -16px 0 16px 2px;
  letter-spacing: 0.03333333333333333rem;
`;

const FloatingUploadButton = styled(Fab)`
  && {
    position: fixed;
    bottom: 3rem;
    right: 1rem;
    min-width: 56px;
    height: 56px;
    z-index: 9999;
    border-radius: 28px;
    cursor: pointer;
    outline: none;
    /* stylelint-disable */
    box-shadow: 0 3px 5px -1px rgba(0,0,0,.2),
    0 6px 10px 0 rgba(0,0,0,.14), 0 1px 18px 0 rgba(0,0,0,.12);

    svg {
      margin: 0;
      fill: var(--white);
    }

    @media (min-width: 1024px) {
      bottom: 1.5rem;
      right: 1.5rem;
    }
  }
`;

const DragAndDropInput = styled.input`
  opacity: 0;
  width: 100%;
  min-height: 300px;
  cursor: pointer;
`;

const UploadIcon = styled(AddIcon)`
  position: absolute;
  z-index: 0;
`;

const LookbookButton = ({ children, ...properties }) => (
  <FloatingUploadButton
    color="primary"
    aria-label="Add"
    tabIndex={-1}
    {...properties}
  >
    <UploadIcon />
    { children }
  </FloatingUploadButton>
);

LookbookButton.propTypes = {
  children: PropTypes.node,
};

LookbookButton.defaultProps = {
  children: undefined,
};

const LookbookUploadButton = ({
  id,
  onChange,
  required,
  multiple,
}) => (
  <LookbookButton>
    <DragAndDropInput
      id={id}
      accept={acceptFiles}
      onChange={onChange}
      type="file"
      required={required}
      multiple={multiple}
    />
  </LookbookButton>
);

LookbookUploadButton.propTypes = {
  id: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  required: PropTypes.bool.isRequired,
  multiple: PropTypes.bool,
};

LookbookUploadButton.defaultProps = {
  multiple: false,
};

export {
  Privacy,
  UploadHint,
  LookbookButton,
  LookbookUploadButton,
};
